import React from 'react'; import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ArticleTitle, ArticleHead, ArticleExtra } from './../../../ui/src/component/article';
import noImageImg from './../../../assets/no-image.png';
import moment from 'moment';
import { staticImageBaseUrl, calendarTimeStylized } from './../../../ui/src/utilities';

const TrafficItem = props => {

    const getTrafficContextImageByCategory = category => {
        switch (category) {
            case 'radars':
                return staticImageBaseUrl('radar.jpg');
            case 'patrols':
                return staticImageBaseUrl('hliadky.jpg');
            case 'accidents':
                return staticImageBaseUrl('nehoda.jpg');
            case 'restrictions':
                return staticImageBaseUrl('obmedzenie.jpg');
            default:
                return noImageImg;
        }
    };

    let now = moment();
    let date = moment(props.item.created_date);
    let dateStr = <span className="text-primary">{date.fromNow()}</span>;
    if (now.diff(date, 'seconds') > 3600) {
        dateStr = calendarTimeStylized(date);
    }

    return <Link to={`/dopravny-servis/${props.item._id}`}>
        <article className="article">
            <ArticleHead
                image={props.item.thumbnail ? getTrafficImageUrl(props.item.thumbnail) : getTrafficContextImageByCategory(props.item.category)}
                title={<ArticleTitle
                    title={props.item.title}
                    subtitle={<span>{props.item.user.firstname} {props.item.user.surname} | {dateStr}</span>}
                    allowShare={false}
                />}
                head={<ArticleExtra iconSrc={getIconForCategory(props.item.category)} iconCircleFill={'transparent'} title={getTrafficNameByCategory(props.item.category)} />}
            >
            </ArticleHead>
        </article>
    </Link>;
};

TrafficItem.defaultProps = {
};

TrafficItem.propTypes = {
    item: PropTypes.object.isRequired
};

export default TrafficItem;

export const getColorByCategory = category => {
    switch (category) {
        case 'radars':
            return '#3AB241';
        case 'patrols':
            return '#0F7FFC';
        case 'accidents':
            return '#FA161B';
        case 'restrictions':
            return '#FB703A';
        default:
            return category;
    }
};

export const getTrafficImageUrl = img => {
    return `${getTrafficImageBaseUrl()}/${img}`;
};

export const getTrafficImageBaseUrl = img => {
    return `https://data.tvkosice.sk/images/base`;
};

export const getTrafficGalleryImageBaseUrl = img => {
    return `https://data.tvkosice.sk/images/`;
};

export const getIconForCategory = (category, isPin = false) => {
    let baseUrl = 'https://data.tvkosice.sk/static/traffic-icons';
    switch (category) {
        case 'radars':
            return `${baseUrl}/radars${isPin ? '-pin' : ''}.svg`;
        case 'patrols':
            return `${baseUrl}/patrols${isPin ? '-pin' : ''}.svg`;
        case 'accidents':
            return `${baseUrl}/accidents${isPin ? '-pin' : ''}.svg`;
        case 'restrictions':
            return `${baseUrl}/restrictions${isPin ? '-pin' : ''}.svg`;
        default:
            return category;
    }
};

export const getTrafficNameByCategory = category => {
    switch (category) {
        case 'radars':
            return "Radar";
        case 'patrols':
            return "Hliadka";
        case 'accidents':
            return "Dopravná nehoda";
        case 'restrictions':
            return "Dopravné obmedzenie";
        default:
            return category;
    }
};


// WEBPACK FOOTER //
// ./src/app/component/trafficItem/trafficItem.js